var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-container"},[_c('iframe',{staticClass:"h-100 w-100",attrs:{"src":_vm.viewerUrl,"frameBorder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }